/* Vera Santori — carrito lateral */
(function () {
  'use strict';

  var SECTION_ID = 'cart-drawer';
  var WRAPPER_ID = 'shopify-section-' + SECTION_ID;
  var isOpen = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function wrapper() {
    return document.getElementById(WRAPPER_ID);
  }

  function drawer() {
    var w = wrapper();
    return w ? w.querySelector('[data-cart-drawer]') : null;
  }

  function setBusy(state) {
    var d = drawer();
    if (d) d.classList.toggle('is-busy', !!state);
  }

  function applyState() {
    var d = drawer();
    if (!d) return;
    d.classList.toggle('is-open', isOpen);
    var overlay = d.querySelector('.vs-cd-overlay');
    if (overlay) overlay.hidden = !isOpen;
    var panel = d.querySelector('.vs-cd-panel');
    if (panel) panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.body.style.overflow = isOpen ? 'hidden' : '';
  }

  function open() {
    isOpen = true;
    applyState();
    var panel = drawer() && drawer().querySelector('.vs-cd-panel');
    if (panel) panel.focus();
  }

  function close() {
    isOpen = false;
    applyState();
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('.vs-cart-link').forEach(function (link) {
      var badge = link.querySelector('span');
      if (typeof count !== 'number') return;
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          link.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
      link.setAttribute('aria-label', 'Cesta con ' + count + ' productos');
    });
  }

  /* ------------------------------------------------------------------
     ANIMACION "AL CARRITO"
     Al anadir una prenda sale un puntito negro desde el boton pulsado,
     sube en curva hasta el icono de la cesta de la cabecera, la cesta
     da un pequeno rebote y despues se abre el carrito lateral.
     Dura ~0,55 s y corre a la vez que la peticion a Shopify, asi que
     casi no retrasa la apertura del carrito.
     Si el movil tiene activado "reducir movimiento" no se anima nada.
     ------------------------------------------------------------------ */
  var FLY_MS = 550;

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function visibleCartIcon() {
    var links = document.querySelectorAll('.vs-cart-link');
    for (var i = 0; i < links.length; i++) {
      var r = links[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return links[i];
    }
    return null;
  }

  function bumpCart(target) {
    target.classList.remove('vs-cart-bump');
    void target.offsetWidth;
    target.classList.add('vs-cart-bump');
    setTimeout(function () { target.classList.remove('vs-cart-bump'); }, 450);
  }

  function flyToCart(origin) {
    return new Promise(function (resolve) {
      var target = visibleCartIcon();
      if (!origin || !target || reduceMotion() || !document.body.animate) { resolve(); return; }

      var from = origin.getBoundingClientRect();
      var to = target.getBoundingClientRect();
      if (!from.width && !from.height) { resolve(); return; }

      var size = 14;
      var x0 = from.left + from.width / 2 - size / 2;
      var y0 = from.top + from.height / 2 - size / 2;
      var x1 = to.left + to.width / 2 - size / 2;
      var y1 = to.top + to.height / 2 - size / 2;
      var dx = x1 - x0;
      var dy = y1 - y0;
      var lift = Math.min(160, Math.abs(dy) * 0.35 + 60);

      var dot = document.createElement('div');
      dot.className = 'vs-fly-dot';
      dot.setAttribute('aria-hidden', 'true');
      dot.style.left = x0 + 'px';
      dot.style.top = y0 + 'px';
      document.body.appendChild(dot);

      var done = false;
      function finish() {
        if (done) return;
        done = true;
        if (dot.parentNode) dot.parentNode.removeChild(dot);
        bumpCart(target);
        resolve();
      }

      /* Curva: el punto sube un poco por encima de la linea recta
         (como si lo lanzaras) y va encogiendo al llegar a la cesta. */
      var anim = dot.animate([
        { transform: 'translate(0px, 0px) scale(1)', opacity: 1 },
        { transform: 'translate(' + (dx * 0.45) + 'px, ' + (dy * 0.45 - lift) + 'px) scale(0.9)', opacity: 1, offset: 0.45 },
        { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(0.35)', opacity: 0.9 }
      ], { duration: FLY_MS, easing: 'cubic-bezier(.45,.05,.4,1)', fill: 'forwards' });

      anim.onfinish = finish;
      setTimeout(finish, FLY_MS + 200);
    });
  }

  /* Refresca el contenido del carrito.
     Importante: cuando el carrito ya existe en la pagina sustituimos SOLO el
     interior del panel. Si reemplazasemos el bloque entero, el navegador
     volveria a montar el panel y el fondo oscuro desde cero y se repetirian
     sus transiciones: durante un segundo el carrito se veia translucido y
     dejaba ver la pagina de detras. */
  function refresh() {
    var w = wrapper();
    if (!w) return Promise.resolve();
    return fetch(root() + '?sections=' + SECTION_ID, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION_ID];
        if (!html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var freshRoot = parsed.querySelector('[data-cart-drawer]');
        if (!freshRoot) return;

        var currentRoot = drawer();
        var currentPanel = currentRoot && currentRoot.querySelector('.vs-cd-panel');
        var freshPanel = freshRoot.querySelector('.vs-cd-panel');

        if (currentPanel && freshPanel) {
          /* Guardamos donde estaba mirando el cliente para devolverlo ahi. */
          var body = currentPanel.querySelector('.vs-cd-body');
          var bodyTop = body ? body.scrollTop : 0;
          var track = currentPanel.querySelector('[data-rec-track]');
          var trackLeft = track ? track.scrollLeft : 0;

          currentPanel.innerHTML = freshPanel.innerHTML;

          var newBody = currentPanel.querySelector('.vs-cd-body');
          if (newBody && bodyTop) newBody.scrollTop = bodyTop;
          var newTrack = currentPanel.querySelector('[data-rec-track]');
          if (newTrack && trackLeft) newTrack.scrollLeft = trackLeft;

          applyState();
          return;
        }

        /* Primera carga o estructura inesperada: reconstruimos entero. */
        var fresh = parsed.getElementById(WRAPPER_ID) || freshRoot;
        w.innerHTML = fresh.id === WRAPPER_ID ? fresh.innerHTML : fresh.outerHTML;
        applyState();
      })
      .catch(function () {});
  }

  function syncCount() {
    return fetch(root() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateHeaderCount(cart.item_count); })
      .catch(function () {});
  }

  function changeLine(line, quantity) {
    setBusy(true);
    return fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateHeaderCount(cart.item_count); })
      .then(refresh)
      .then(function () { setBusy(false); })
      .catch(function () { setBusy(false); });
  }

  /* Si el carrito ya esta abierto (recomendaciones), el puntito no
     tiene a donde ir: la cesta de la cabecera queda tapada. */
  function maybeFly(origin) {
    return isOpen ? Promise.resolve() : flyToCart(origin);
  }

  function addVariant(id, quantity, origin) {
    setBusy(true);
    var fly = maybeFly(origin);
    var request = fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity || 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return syncCount(); })
      .then(refresh);

    return Promise.all([request, fly])
      .then(function () { setBusy(false); open(); })
      .catch(function () { setBusy(false); });
  }

  function addFromForm(form, origin) {
    setBusy(true);
    var fly = maybeFly(origin);
    var request = fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function () { return syncCount(); })
      .then(refresh);

    return Promise.all([request, fly])
      .then(function () { setBusy(false); open(); })
      .catch(function () { setBusy(false); form.submit(); });
  }

  /* --- Eventos globales --- */

  document.addEventListener('click', function (event) {
    var cartLink = event.target.closest('.vs-cart-link, [data-cart-drawer-open]');
    if (cartLink && wrapper()) {
      event.preventDefault();
      refresh().then(open);
      return;
    }

    /* Tocar la parte oscurecida de la tienda (a la izquierda del
       carrito) tambien lo cierra. */
    if (event.target.closest('[data-cart-close]') || (isOpen && event.target.closest('.vs-cd-overlay'))) {
      event.preventDefault();
      close();
      return;
    }

    var change = event.target.closest('[data-cart-change], [data-cart-remove]');
    if (change) {
      event.preventDefault();
      var line = parseInt(change.getAttribute('data-line'), 10);
      var qty = change.hasAttribute('data-quantity') ? parseInt(change.getAttribute('data-quantity'), 10) : 0;
      if (!isNaN(line) && qty >= 0) changeLine(line, qty);
      return;
    }

    /* Tallas en las tarjetas de coleccion: al pulsar una, esa talla entra en la
       cesta y se abre el carrito, sin pasar por la ficha del producto. */
    var sizeBtn = event.target.closest('[data-card-size]');
    if (sizeBtn && wrapper()) {
      event.preventDefault();
      if (sizeBtn.disabled) return;

      var cardEl = sizeBtn.closest('[data-product-card]');
      var box = cardEl && cardEl.querySelector('[data-card-sizes]');
      var dataEl = cardEl && cardEl.querySelector('[data-card-variants]');
      if (!box || !dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var sizePos = parseInt(box.getAttribute('data-size-pos'), 10);
      var colorPos = parseInt(box.getAttribute('data-color-pos'), 10);
      var wanted = (sizeBtn.getAttribute('data-size') || '').toLowerCase();
      var activeSwatch = cardEl.querySelector('[data-card-swatch].is-active');
      var wantedColor = activeSwatch ? (activeSwatch.getAttribute('data-color') || '').toLowerCase() : '';

      var norm = function (value) {
        return String(value == null ? '' : value).trim().toLowerCase();
      };

      var matches = function (variant, useColor) {
        if (!variant.available) return false;
        if (norm(variant.options[sizePos - 1]) !== wanted) return false;
        if (useColor && colorPos && wantedColor) {
          return norm(variant.options[colorPos - 1]) === wantedColor;
        }
        return true;
      };

      var chosen = null;
      variants.forEach(function (variant) {
        if (!chosen && matches(variant, true)) chosen = variant;
      });
      if (!chosen) {
        variants.forEach(function (variant) {
          if (!chosen && matches(variant, false)) chosen = variant;
        });
      }
      if (!chosen) return;

      sizeBtn.classList.add('is-busy');
      addVariant(chosen.id, 1, sizeBtn).then(function () {
        sizeBtn.classList.remove('is-busy');
      });
      return;
    }

    var add = event.target.closest('[data-rec-add]');
    if (add) {
      event.preventDefault();
      var card = add.closest('.vs-cd-rec');
      var field = card && card.querySelector('[data-rec-variant]');
      if (field && field.value) {
        add.disabled = true;
        addVariant(field.value, 1, add);
      }
      return;
    }

    var arrow = event.target.closest('[data-rec-prev], [data-rec-next]');
    if (arrow) {
      event.preventDefault();
      var track = arrow.closest('.vs-cd-recs').querySelector('[data-rec-track]');
      var card2 = track && track.querySelector('.vs-cd-rec');
      if (!track || !card2) return;
      var step = card2.getBoundingClientRect().width + 12;
      track.scrollBy({ left: arrow.hasAttribute('data-rec-next') ? step : -step, behavior: 'smooth' });
    }
  });

  /* Capturamos en fase de captura para adelantarnos a cualquier otro script
     que quiera llevarse al cliente a la pagina de la cesta: aqui se anade la
     prenda, se abre el carrito lateral y el cliente sigue comprando. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.hasAttribute('data-no-drawer')) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (!wrapper()) return;
    event.preventDefault();
    event.stopPropagation();
    var origin = event.submitter || form.querySelector('[type="submit"]') || form;
    addFromForm(form, origin);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen) close();
  });

  document.addEventListener('DOMContentLoaded', applyState);
})();
